import { ITableField } from 'shared/Table'
import textUtils from 'utils/text.utils'
import { IProjectCheckpoint } from '../../projectCheckpoints.types'
import CheckpointStatusCell from './CheckpointStatusCell'

const checkpointsTableFields: ITableField<IProjectCheckpoint, keyof IProjectCheckpoint>[] = [
  { key: 'id', getter: (item) => item.id.toString(), sortGetter: (item) => item.id, header: 'ID', width: '200px' },
  {
    key: 'name',
    getter: (item) => item.name.toString(),
    sortGetter: (item) => item.name,
    header: 'Название',
    width: '300px',
  },
  {
    key: 'duration',
    getter: (item) => {
      const days = item.duration / 86400
      return `${days} ` + textUtils.declineWordDependingOnCount(days, ['дней', 'день', 'дня'])
    },
    sortGetter: (item) => item.duration,
    header: 'Длительность',
    width: '200px',
  },
  {
    key: 'isVisible',
    getter: (item) => <CheckpointStatusCell item={item} />,
    sortGetter: (item) => (item.isVisible !== false ? 1 : 0),
    header: 'Статус',
    width: '220px',
  },
]

export default checkpointsTableFields
